import { useEffect } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Dialog, Portal, useTheme } from "react-native-paper";

export function FirebaseUIContainer({
  style,
  onDismiss,
  children,
}: React.PropsWithChildren<{
  style?: StyleProp<ViewStyle>;
  onDismiss: () => void;
}>) {
  const theme = useTheme();
  useEffect(() => {
    const { colors, roundness } = theme;
    const properties = {
      "--fui-primary": colors.primary,
      "--fui-primary-hover": colors.inversePrimary,
      "--fui-primary-surface": colors.surface,
      "--fui-text": colors.onBackground,
      "--fui-text-muted": colors.onSurface,
      "--fui-background": colors.background,
      "--fui-input": colors.onBackground,
      "--fui-error": colors.error,
      "--fui-radius": `${roundness * 5}px`,
      "--fui-radius-card": `${roundness * 4}px`,
      "--mui-primary": colors.primary,
      "--mui-on-primary": colors.onPrimary,
    };
    for (const [property, value] of Object.entries(properties)) {
      if (!value) continue;
      document.documentElement.style.setProperty(property, value);
    }
  }, [theme]);

  return (
    <Portal>
      <Dialog visible style={style} onDismiss={onDismiss}>
        <Dialog.Content>
          <div
            style={{
              ...theme.fonts.bodyMedium,
              color: theme.colors.onBackground,
              lineHeight: undefined,
            }}
          >
            {children}
          </div>
        </Dialog.Content>
      </Dialog>
    </Portal>
  );
}
